import { deleteCuration } from '@musinsa/apis-curator';
import {
  lazyPipe,
  validateServiceRequest,
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type {
  DeleteCurationServiceRequestDto,
  DeleteCurationServiceResponseDto,
} from './delete-curation.dto';
import {
  DeleteCurationServiceRequestDtoSchema,
  DeleteCurationServiceResponseDtoSchema,
} from './delete-curation.dto';

export const deleteCurationService = withServiceErrorCapture(
  lazyPipe(
    validateServiceRequest(DeleteCurationServiceRequestDtoSchema),
    async (request: DeleteCurationServiceRequestDto): Promise<DeleteCurationServiceResponseDto> => {
      const response = await deleteCuration({ curationId: request.curationId });

      if (response.meta?.result === 'FAIL') {
        throw new Error(response.meta?.message ?? '큐레이션 삭제에 실패했습니다');
      }

      return {
        success: true,
      };
    },
    validateServiceResponse(DeleteCurationServiceResponseDtoSchema),
  ),
);
